import { render, staticRenderFns } from "./HubungiKami.vue?vue&type=template&id=740ba3b3&scoped=true"
import script from "./HubungiKami.vue?vue&type=script&lang=js"
export * from "./HubungiKami.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740ba3b3",
  null
  
)

export default component.exports